import app from './app.json';
import common from './common.json';
import page from './page.json';
const hrHR = {
    app,
    common,
    page
};
export default hrHR;
